var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"product-attribute bg-gray-200 leading-tight"},[_c('td',{staticClass:"text-right w-1/3 md:w-1/4 p-2 pr-3 py-4"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('td',{staticClass:"font-mono font-bold"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }